<template>
  <v-footer color="#4c4c4c" height="auto">
    <v-row color="#4c4c4c" class="pt-3 white--text text-center">
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="3">
            <v-main style=" padding: 10px; padding-left:0px;">
              <v-card color="#4c4c4c" tile flat align-center justify-center fill-height>
                <img
                    class="logo_image_footer ma-0"

                    src="../assets/img/logo-sivi.png"
                />
                <v-card-text
                    align="left"
                    style="color: #818181;"
                >Trg hrvatskih velikana 1, 88000 Mostar, BiH,
                  <br>Tel: +387 36 337-070, Fax: +387 36 320-885
                </v-card-text>
              </v-card>
            </v-main>
          </v-col>

          <v-col cols="12" sm="7">
            <v-layout row wrap>
              <template v-for="(item, i) in fakulteti">
                <v-col
                    cols="6"
                    md="3"
                    class="custom-box footer1_link meni_txt footer_font py-3"
                    :key="i"
                >
                  <div class="pa-2"><a class="custom-box footer1_link meni_txt footer_font"
                                       style="text-decoration: none;" :href="item.link" target="_blank">
                    {{ item.fax }}</a></div>
                  <v-divider v-if="i < 8" color="#818181"></v-divider>
                  <v-divider v-else-if="i < 10" color="#818181" class="hidden-md-and-up"></v-divider>
                </v-col>
              </template>
            </v-layout>
          </v-col>
          <v-col cols="12" sm="2">
            <v-row>
              <v-col cols="12" style="color: #818181" class="pb-3">Društvene mreže</v-col>
              <v-col cols="12"><a style="display: flex" class="drustvene" href="https://www.facebook.com/svemo.ba/"
                                  target="_blank">
                <v-icon left class="icon-list" size="18">fab fa-facebook</v-icon>
                <span>Facebook</span></a></v-col>
              <v-col cols="12"><a style="display: flex" class="drustvene" href="https://twitter.com/sve_mostar"
                                  target="_blank">
                <v-icon left class="icon-list" size="18">fab fa-twitter-square</v-icon>
                <span>Twitter</span></a></v-col>
              <v-col cols="12"><a style="display: flex" class="drustvene"
                                  href="https://www.instagram.com/sveucilisteumostaru/?hl=hr" target="_blank">
                <v-icon left class="icon-list" size="18">fab fa-instagram</v-icon>
                <span>Instagram</span></a></v-col>
              <v-col cols="12"><a style="display: flex" class="drustvene"
                                  href="https://www.youtube.com/channel/UCzjzEJSfK2fuBkitcDV5-0w" target="_blank">
                <v-icon left class="icon-list" size="18">fab fa-youtube-square</v-icon>
                <span>Youtube</span></a></v-col>
            </v-row>
          </v-col>
        </v-row>
        <br>
        <!-- <v-divider style="margin-top:40px" fluid color="#818181"></v-divider> -->

        <v-card-text class="footer-title" style="font-size: 17px;">
          &copy;{{ new Date().getFullYear() }} —
          <strong><a style="text-decoration: none;" class="footer-link" href="http://sumit.sum.ba/" target="_blank">IT
            Centar Sveučilišta u Mostaru</a></strong>
        </v-card-text>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    fakulteti: [
      {
        fax: 'Agronomski i prehrambeno-tehnološki fakultet',
        link: 'http://aptf.sum.ba/hr/'
      },
      {
        fax: 'Akademija likovnih umjetnosti',
        link: 'http://alu.sum.ba/'
      },
      {
        fax: 'Ekonomski fakultet',
        link: 'http://ef.sum.ba/'
      },
      {
        fax: 'Fakultet prirodoslovno-matematičkih i odgojnih znanosti',
        link: 'http://fpmoz.sum.ba/'
      },
      {
        fax: 'Fakultet strojarstva, računarstva i elektrotehnike',
        link: 'http://fsre.sum.ba/'
      },
      {
        fax: 'Fakultet zdravstvenih studija',
        link: 'http://fzs.sum.ba/'
      },
      {
        fax: 'Farmaceutski fakultet',
        link: 'http://farf.sum.ba/'
      },
      {
        fax: 'Filozofski fakultet',
        link: 'http://ff.sum.ba/'
      },
      {
        fax: 'Građevinski fakultet',
        link: 'http://gf.sum.ba/'
      },
      {
        fax: 'Medicinski fakultet',
        link: 'http://mef.sum.ba/'
      },
      {
        fax: 'Pravni fakultet',
        link: 'http://pf.sum.ba/'
      }
      ,
      {
        fax: 'Sveučilište u Mostaru',
        link: 'https://sum.ba/'
      }
    ]
  })

}
</script>

<style lang="scss">
.custom-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    cursor: pointer;
  }
}

.footer1_link {
  color: #818181 !important;

  font-size: 14px;
}

.footer1_link:hover {
  color: white !important;
}
</style>